export const ConfigLayout = [
    {
        path: "/component-examples/",
        layoutComp: "PageLayout"
    },
    {
        path: "/advanced-renal-cell-carcinoma/dosing/",
        layoutComp: "PageLayout"
    },
    {
        path: "/advanced-renal-cell-carcinoma/efficacy/",
        layoutComp: "PageLayout"
    },
    {
        path: "/advanced-renal-cell-carcinoma/guidelines/",
        layoutComp: "PageLayout"
    },
    {
        path: "/advanced-renal-cell-carcinoma/",
        layoutComp: "PageLayout"
    },
    {
        path: "/advanced-renal-cell-carcinoma/mechanism-of-action/",
        layoutComp: "PageLayout"
    },
    {
        path: "/advanced-renal-cell-carcinoma/resources-and-access/",
        layoutComp: "PageLayout"
    },
    {
        path: "/advanced-renal-cell-carcinoma/safety/",
        layoutComp: "PageLayout"
    },
    {
        path: "/advanced-renal-cell-carcinoma/treatment-sequencing-and-patient-profiles/",
        layoutComp: "PageLayout"
    },
    {
        path: "/von-hippel-lindau/adverse-reaction-profile/",
        layoutComp: "PageLayout"
    },
    {
        path: "/von-hippel-lindau/dosing/",
        layoutComp: "PageLayout"
    },
    {
        path: "/von-hippel-lindau/efficacy/",
        layoutComp: "PageLayout"
    },
    {
        path: "/von-hippel-lindau/guidelines/",
        layoutComp: "PageLayout"
    },
    {
        path: "/von-hippel-lindau/",
        layoutComp: "PageLayout"
    },
    {
        path: "/von-hippel-lindau/mechanism-of-action/",
        layoutComp: "PageLayout"
    },
    {
        path: "/von-hippel-lindau/patient-identification/",
        layoutComp: "PageLayout"
    },
    {
        path: "/von-hippel-lindau/resources/",
        layoutComp: "PageLayout"
    },
    {
        path: "/von-hippel-lindau/what-is-von-hippel-lindau/",
        layoutComp: "PageLayout"
    },
    {
        path: "/adjuvant-renal-cell-carcinoma/",
        layoutComp: "MultiBrandPageLayout"
    },
    {
        path: "/",
        layoutComp: "MultiBrandPageLayout"
    },
    {
        path: "/site-map/",
        layoutComp: "MultiBrandPageLayout"
    },
    {
        path: "/contact-us/",
        layoutComp: "MultiBrandPageLayout"
    },
    {
        path: "/404/",
        layoutComp: "MultiBrandPageLayout"
    },
    {
        path:"/adjuvant-renal-cell-carcinoma/risk-of-recurrence/",
        layoutComp: "MultiBrandPageLayout"
    },
    {
        path: "/adjuvant-renal-cell-carcinoma/mechanisms-of-action/",
        layoutComp: "MultiBrandPageLayout"
    },
    {
        path:"/adjuvant-renal-cell-carcinoma/efficacy-and-safety/",
        layoutComp: "MultiBrandPageLayout"
    },
    {
        path:"/adjuvant-renal-cell-carcinoma/dosing-and-administration/",
        layoutComp: "MultiBrandPageLayout"
    },
    {
        path:"/adjuvant-renal-cell-carcinoma/resources-and-ordering/",
        layoutComp: "MultiBrandPageLayout"
    },
]